import owd from 'owd/owd';

export default class Lineup extends owd.Component {
	init() {
        this.sliderNavigation = $('.tickets-nav--mobile');
        this.sliderNavigationInstance = this.sliderNavigation.data('swiperInstance');

		this.bind();
	}

	bind() {
        this.on('click', (e) => {
            e.preventDefault();
            e.stopPropagation();

            if(this.$element.hasClass('active')) {
                return false;
            }

            const url = this.$element.attr('href');
            const index = this.$element.data('lineup');


            $('.tickets-nav-item.active').removeClass('active').trigger('blur');
            $(`[data-lineup=${index}]`).addClass('active');

            if(window.matchMedia('(min-width: 1023px)').matches) {
                this.sliderNavigationInstance.slideToLoop(index, 0);
            }

            this.app.getModule('ajax').loadPage(url, true, 'lineup');
        });
    }
x
    destroy() {
        super.destroy();
    }
}

owd.registerComponent('lineup', {
	component: Lineup
});
